import React from "react";

import styles from "./Section3.module.scss";

export const Section3 = function () {
  return (
    <section id="benefits" className={`${styles.section3Wrapper} cc--component-container`}>
      <div className={styles.section3Container}>
        <h3>You&rsquo;ll Walk Away With:</h3>
        <div className={styles.section3Content}>
          <div className={styles.firstCol}>
            <span>1</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              The ability to create a positive, supportive, and inclusive learning environment through the application
              of world-class teaching practices.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>2</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              The confidence to move into and succeed in teaching roles at any level of the higher education teaching
              spectrum by developing a comprehensive teaching portfolio that acts as a testament to your current
              experience, goals, and skills as a teacher.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>3</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              Practical strategies for classroom management and lesson-plan design delivered through a fully supported,
              interactive learning journey.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
